<template>
  <div>
    <p class="clearfix"></p>
    <!-- <general-top-bar :title="$t('newsletterCard.titleVideoSupport')"></general-top-bar> -->
    <!-- <div class="category-top-bar">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="() => {$router.push('/newsletter')}">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
      </div>
    </div> -->
    <!-- <h2>{{ $t('newsletterCard.titleVideoSupport') }}</h2> -->
    <div class="support">
      <div class="link-container">
        <a href="https://helpdesk.taptasty.com/ro/" target="_blank" rel="noopener noreferrer">{{ $t('newsletterCard.helpVideoSupport') }}</a>
      </div>
      <div class="pull-right">
        <el-input
          type="text"
          v-model="searchQuery"
          :placeholder="$t('newsletterCard.searchPlaceholder')"
          class="icon-search"
          clearable
        ></el-input>
      </div>
    </div>
    <div class="card mar-to-15">
      <div class="card-content">
        <div class="video-grid">
          <VideoSupportCard
            v-for="video in displayedVideos"
            :key="video.key"
            :src="video.src"
            :title="video.title"
          />
        </div>
        <div v-if="filteredVideos.length === 0" class="no-results-message">
          {{ $t('newsletterCard.noResultsMessage') }}
        </div>
        <br>
        <el-pagination class="active-pagination"
          :current-page.sync="pagination.currentPage"
          :page-size="pagination.pageSize"
          :total="filteredVideos.length"
          layout="prev, pager, next"
          @current-change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VideoSupportCard from './VideoSupportCard'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'

export default {
  name: 'VideoSupport',
  components: {
    VideoSupportCard
    // GeneralTopBar
  },
  data () {
    return {
      allVideos: [
        // Add your video objects here:
        { src: 'https://www.youtube.com/embed/4eczYFQS4hA', title: 'Demo Sistem TapTasty' },
        { src: 'https://www.youtube.com/embed/63rU-z9eIHo?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adăugăm un banner oferte în TapTasty?' },
        { src: 'https://www.youtube.com/embed/9H5rj1veCzY', title: 'Cum adaug și șterg filtrele unui produs în TapTasty?' },
        { src: 'https://www.youtube.com/embed/cIqper3XBiU?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cu adaug o pagină personalizată în TapTasty?' },
        { src: 'https://www.youtube.com/embed/yc2opgjLkB0?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug o opțiune produs în TapTasty?' },
        { src: 'https://www.youtube.com/embed/CYKdOxTLAV0?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum vizualizezi lista de clienți în TapTasty?' },
        { src: 'https://www.youtube.com/embed/EfUsmQAWsxI?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum vizualizez istoricul comenzilor unui client în TapTasty?' },
        { src: 'https://www.youtube.com/embed/qMbIYBGgCt0?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum vizualizez informațiile unui client în TapTasty?' },
        { src: 'https://www.youtube.com/embed/0WjBNd3Cm8M?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum vizualizez un feedback în TapTasty?' },
        { src: 'https://www.youtube.com/embed/vk0fSikUx1k?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum vizualizez meniul QR în TapTasty?' },
        { src: 'https://www.youtube.com/embed/ZpJda4HyYdg?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum șterg un produs în TapTasty?' },
        { src: 'https://www.youtube.com/embed/ulinM2wIuJM?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum ștergem opțiune produs în TapTasty?' },
        { src: 'https://www.youtube.com/embed/jsJlatp7iAs?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum șterg o categorie în TapTasty?' },
        { src: 'https://www.youtube.com/embed/lGwdMphOe-w?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum șterg etichetarea clienților în TapTasty?' },
        { src: 'https://www.youtube.com/embed/BxNndq5KgD8?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum sortez categoriile în TapTasty?' },
        { src: 'https://www.youtube.com/embed/8d_Vtii0d-Y?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum setez punctele de loialitate în TapTasty?' },
        { src: 'https://www.youtube.com/embed/vid31FqL81A?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum etichetez clienții în TapTasty?' },
        { src: 'https://www.youtube.com/embed/pGKG9LinAeY?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum editez un produs existent în TapTasty?' },
        { src: 'https://www.youtube.com/embed/vzG9xoWFrwE?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum editez paginile informative în TapTasty?' },
        { src: 'https://www.youtube.com/embed/4uobb3y0tsY?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug puncte de loialitate unui client în TapTasty?' },
        { src: 'https://www.youtube.com/embed/1UEyLE-zgFs?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum dezactivez sau șterg o campanie în TapTasty?' },
        { src: 'https://www.youtube.com/embed/Rv9dJ1byuLc?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug un produs nou în TapTasty?' },
        { src: 'https://www.youtube.com/embed/qLczEQc9aZY?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug comentariu la un client în TapTasty?' },
        { src: 'https://www.youtube.com/embed/1d7Je3K-pXY?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug o promoție în TapTasty?' },
        { src: 'https://www.youtube.com/embed/joppOQr7jqw?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug o campanie nouă în TapTasty?' },
        { src: 'https://www.youtube.com/embed/p7mLJoFZ3cE?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum trimit o campanie în TapTasty?' },
        { src: 'https://www.youtube.com/embed/ZSs0n2D68kk?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug o categorie în TapTasty?' },
        { src: 'https://www.youtube.com/embed/MZ0hJwPuRM8?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug o categorie de top nouă în TapTasty?' },
        { src: 'https://www.youtube.com/embed/QUfrropYOK0?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum setez regulile de livrare în TapTasty?' },
        { src: 'https://www.youtube.com/embed/BtaJjt-mpO8?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug și șterg etichete taxe în TapTasty?' },
        { src: 'https://www.youtube.com/embed/mMVG87qjwGM?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug taxe de bacșiș în TapTasty?' },
        { src: 'https://www.youtube.com/embed/oxyUjsG_A70?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum vizualizez detaliile comenzii în TapTasty?' },
        { src: 'https://www.youtube.com/embed/Joy60i7Ywg0?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum vizualizez detaliile companiei în TapTasty?' },
        { src: 'https://www.youtube.com/embed/qe2khy0UDHo?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum editez o notificare în TapTasty?' },
        { src: 'https://www.youtube.com/embed/KB0GM6joByY?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum setez raza de livrare în TapTasty?' }
      ],
      pagination: {
        currentPage: 1,
        pageSize: 6
      },
      searchQuery: ''
    }
  },
  computed: {
    displayedVideos () {
      const start = (this.pagination.currentPage - 1) * this.pagination.pageSize
      const end = start + this.pagination.pageSize
      // return this.allVideos.slice(start, end)
      return this.filteredVideos.slice(start, end)
    },
    filteredVideos () {
      if (this.searchQuery.trim() === '') {
        return this.allVideos
      }
      const normalizedSearchQuery = this.removeDiacritics(this.searchQuery).toLowerCase()
      // return this.allVideos.filter(video => video.title.toLowerCase().includes(this.searchQuery.toLowerCase()))
      return this.allVideos.filter(video => this.removeDiacritics(video.title).toLowerCase().includes(normalizedSearchQuery))
    }
  },
  methods: {
    handlePageChange (page) {
      this.pagination.currentPage = page
    },
    removeDiacritics (str) {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    }

  }
}
</script>

<style scoped>
.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  justify-items: center;
  margin-bottom: 20px;
}
.support{
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.arrow-icon {
  margin-right: 3px;
}

.no-results-message {
  font-size: 18px;
  color: #888;
  text-align: center;
  margin-top: 20px;
}
.video-title {
  height: 30px;
  font-size: 18px;
  font-weight: 500;
}

div.el-pagination.active-pagination,
.el-pager li {
  background: #F4F6FF !important;
}

/* Add a media query for larger screens (e.g., monitors) */
@media screen and (min-width: 1440px) {
  .video-grid {
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/Newsletter/Tabs/VideoSupport.vue